let _ = t => t,
  _t;
import _styled from "styled-components";
import I18n from 'I18n';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { getRecipientKey } from 'conversations-thread-data/channel-configuration/public/operators';
import { CALYPSO, EERIE } from 'HubStyleTokens/colors';
import RecipientFieldExpandButton from './RecipientFieldExpandButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FIELD_VISIBILITY_CONTROLS_HEIGHT = 40;
export const FieldVisibilityControlsWrapper = styled.div.withConfig({
  displayName: "FieldVisibilityControls__FieldVisibilityControlsWrapper",
  componentId: "sc-1rw5bxj-0"
})(["display:flex;align-items:center;flex-shrink:0;height:", "px;.editor-collapse-button,.show-cc-button,.show-bcc-button{margin-left:5px;margin-top:0 !important;}"], FIELD_VISIBILITY_CONTROLS_HEIGHT);
const renderRecipientsExpandButtons = ({
  index,
  recipient,
  recipientFieldsExpansionState,
  setRecipientFieldsExpansionState,
  showCCBCCIconButtons
}) => {
  const recipientKey = getRecipientKey(recipient);
  return /*#__PURE__*/_jsx(RecipientFieldExpandButton, {
    recipientKey: recipientKey,
    index: index,
    recipientFieldsExpansionState: recipientFieldsExpansionState,
    setRecipientFieldsExpansionState: setRecipientFieldsExpansionState,
    showCCBCCIconButtons: showCCBCCIconButtons
  }, recipientKey);
};
export const FieldVisibilityControls = ({
  recipientsFields,
  recipientFieldsExpansionState,
  setRecipientFieldsExpansionState,
  handleCollapseButtonOnClick,
  showCCBCCIconButtons,
  showSenderSubjectFields
}) => {
  const verticalMenuTooltip = showSenderSubjectFields ? I18n.text('composer-ui.metadata-editor.field-visibility-controls.hide-sender-and-subject') : I18n.text('composer-ui.metadata-editor.field-visibility-controls.edit-sender-and-subject');
  const buttonTestId = showSenderSubjectFields ? 'metada-expand-button-collapse' : 'metada-expand-button-expand';
  return /*#__PURE__*/_jsx(FieldVisibilityControlsWrapper, {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [recipientsFields.map((recipient, index) => {
        if (index === 0) {
          /* Skips the first field as it'd always be visible */
          return null;
        }
        return renderRecipientsExpandButtons({
          recipient,
          index,
          recipientFieldsExpansionState,
          setRecipientFieldsExpansionState,
          showCCBCCIconButtons
        });
      }), /*#__PURE__*/_jsx(UIIconButton, {
        className: "editor-collapse-button",
        onClick: handleCollapseButtonOnClick,
        placement: "top",
        tooltip: verticalMenuTooltip,
        use: "link",
        "data-selenium-test": buttonTestId,
        children: /*#__PURE__*/_jsx(_StyledUIIcon, {
          name: "verticalMenu",
          size: "small",
          className: "m-right-0",
          color: EERIE
          // @ts-expect-error legacy
        })
      })]
    })
  });
};
FieldVisibilityControls.displayName = 'FieldVisibilityControls';
var _StyledUIIcon = _styled(UIIcon)(_t || (_t = _`
              :hover {
                color: ${0} !important;
              }
            `), CALYPSO);